if (!customElements.get('cart-donation')) {
  customElements.define(
    'cart-donation',
    class CartDonation extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onClick.bind(this));

        if (this.dataset.removeOrphan === 'true' && this.getDonationLineKeys().length) {
          this.updateDonation();
        } else if (this.dataset.normalizeDonation === 'true' && this.dataset.selectedVariantId) {
          this.updateDonation(this.dataset.selectedVariantId);
        }
      }

      onClick(event) {
        const removeButton = event.target.closest('[data-remove-donation]');
        const amountButton = event.target.closest('[data-variant-id]');

        if (removeButton) {
          this.updateDonation();
          return;
        }

        if (!amountButton || amountButton.disabled || amountButton.getAttribute('aria-pressed') === 'true') return;

        this.updateDonation(amountButton.dataset.variantId);
      }

      getDonationLineKeys() {
        return (this.dataset.donationLineKeys || '')
          .split(',')
          .map((key) => key.trim())
          .filter(Boolean);
      }

      getSectionsToRender() {
        const drawer = document.querySelector('cart-drawer');
        return drawer ? drawer.getSectionsToRender().map((section) => section.id) : ['cart-drawer', 'cart-icon-bubble'];
      }

      setLoading(isLoading) {
        this.setAttribute('aria-busy', String(isLoading));
        this.querySelectorAll('button').forEach((button) => {
          if (isLoading) {
            button.dataset.wasDisabled = String(button.disabled);
            button.disabled = true;
          } else {
            button.disabled = button.dataset.wasDisabled === 'true';
          }
        });
      }

      showError(message) {
        const status = this.querySelector('.cart-donation__status');
        if (status) status.textContent = message;
      }

      async updateDonation(variantId = null) {
        if (this.isUpdating) return;

        this.isUpdating = true;
        this.setLoading(true);
        this.showError('');

        try {
          const donationLineKeys = this.getDonationLineKeys();
          let state;

          if (variantId && donationLineKeys.length) {
            const removalResponse = await fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              body: JSON.stringify({
                updates: Object.fromEntries(donationLineKeys.map((key) => [key, 0])),
              }),
            });
            const removalState = await removalResponse.json();

            if (!removalResponse.ok || removalState.status) {
              throw new Error(removalState.description || removalState.message || 'Unable to update your donation.');
            }
          }

          if (variantId) {
            const addResponse = await fetch(`${routes.cart_add_url}`, {
              ...fetchConfig(),
              body: JSON.stringify({
                items: [
                  {
                    id: Number(variantId),
                    quantity: 1,
                  },
                ],
                sections: this.getSectionsToRender(),
                sections_url: window.location.pathname,
              }),
            });
            state = await addResponse.json();

            if (!addResponse.ok || state.status) {
              throw new Error(state.description || state.message || 'Unable to update your donation.');
            }
          } else {
            const removalResponse = await fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              body: JSON.stringify({
                updates: Object.fromEntries(donationLineKeys.map((key) => [key, 0])),
                sections: this.getSectionsToRender(),
                sections_url: window.location.pathname,
              }),
            });
            state = await removalResponse.json();

            if (!removalResponse.ok || state.status) {
              throw new Error(state.description || state.message || 'Unable to update your donation.');
            }
          }

          const drawer = document.querySelector('cart-drawer');
          if (drawer) drawer.classList.toggle('is-empty', state.item_count === 0);

          await publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-donation',
            cartData: state,
            variantId,
          });

          if (drawer) drawer.renderContents(state);
        } catch (error) {
          this.showError(error.message || 'Unable to update your donation. Please try again.');
          this.setLoading(false);
        } finally {
          this.isUpdating = false;
        }
      }
    }
  );
}
